<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import GenericButton from '@/components/generic/GenericButton.vue';
import TextInput from '@/components/form/TextInput.vue';
import { users } from '@/api/common';

// Port van common/components/registration/RegisterNewsletter.vue uit ui-v1: de
// balk onderin de schil. ui-v1 toont hem alleen aan een ingelogde gebruiker die
// nog niet is ingeschreven, en verbergt hem zodra dat gelukt is.
const store = useStore();

const email = ref('');
const errors = ref({});
const completed = ref(false);
const saving = ref(false);

const user = computed(() => store.state.user || {});
const isVisible = computed(() => Boolean(user.value.isAuthenticated) && !user.value.news_letter);

// ui-v1 vult het veld bij het aanmaken van het component met het eigen adres.
// De footer mount hier al voordat `users/current/` binnen is, dus dat gebeurt
// zodra de gebruiker bekend wordt — en alleen als er nog niets is ingetypt.
watch(() => user.value.username, (username) => {
  if (username && !email.value) {
    email.value = username;
  }
}, { immediate: true });

const submit = async () => {
  errors.value = {};
  saving.value = true;

  const response = await users.registerNewsletter(email.value);

  saving.value = false;

  if (response.status === 400) {
    errors.value = response.data || {};
    return;
  }

  completed.value = true;
};
</script>

<template>
  <div v-if="isVisible" class="newsletter-bar bg-secondary text-white py-2">
    <!-- Over de hele breedte van de balk, met alles in het midden. -->
    <div class="container-fluid px-3">
      <div v-if="completed" class="d-flex justify-content-center">
        {{ $t('sentence.newsletter_registration_success') }}
      </div>

      <form
        v-else
        class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3"
        @submit.prevent="submit"
      >
        <div class="text-center text-md-start">{{ $t('sentence.stay_in_touch') }}</div>
        <!--
          Veld en knop los van elkaar, met ruimte ertussen, en de knop een gewone
          knop met ronde hoeken in plaats van vastgeplakt aan het veld.
        -->
        <div class="newsletter-input">
          <text-input
            v-model="email"
            type="email"
            placeholder="word.email"
            no-margin
            :errors="errors.email || []"
          />
        </div>
        <generic-button
          label="phrase.register"
          button-style="primary"
          type="submit"
          class="mb-0"
          :is-disabled="saving"
        />
      </form>
    </div>
  </div>
</template>

<style scoped>
.newsletter-input {
  width: 100%;
  max-width: 20rem;
}
</style>
